import { BaseService } from './base-service'
import { Observable } from 'rxjs'
import { SubjectAPIConstant } from '@/api/constant/subject'
import { AccountPageRequestModel, AccountPageRecord } from '@/api/model/account'
import { SubjectPageRequestModel, SubjectPageList } from '@/api/model/subject'
import { Page } from '@/api/model/base'

export class SubjectService extends BaseService {
    protected subjectConstant: SubjectAPIConstant
    constructor() {
        super()
        this.subjectConstant = new SubjectAPIConstant()
    }

    queryFundPage(data: SubjectPageRequestModel): Observable<Page<SubjectPageList>> {
        return this.request(this.subjectConstant.queryFundPage(data))
    }
}
